export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBIuZ5cZdCI0v6cez-Dp3N1ztb3R8iNx_w",
    authDomain: "qrcode-5bbcd.firebaseapp.com",
    projectId: "qrcode-5bbcd",
    storageBucket: "qrcode-5bbcd.firebasestorage.app",
    messagingSenderId: "848046456770",
    appId: "1:848046456770:web:dd3845f60fae702168e05b",
    measurementId: "G-CRJFCGW7W4"
  }
};
